import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import axios from 'axios'
import {toggle} from 'opticks'

import {getUser} from '../modules/selectors'
import {setAvailableRedeemableVioCash} from '../modules/slice'
import {getUserSessionService} from '../services'

const buildConfigHeader = async () => {
  const {idToken} = await getUserSessionService()

  const config = {
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json'
    }
  }

  return config
}

export const FetchCashback = ({
  apiUrl = 'https://api.dev-membership.vio.com/cashback'
}: {
  apiUrl?: string
}) => {
  const dispatch = useDispatch()
  const user = useSelector(getUser)

  useEffect(() => {
    const getCashBackValue = async () => {
      try {
        const config = await buildConfigHeader()
        const {data} = await axios.post(apiUrl, {}, config)

        dispatch(setAvailableRedeemableVioCash(data.cashbackTotal))
      } catch (error) {
        console.log(error)
      }
    }

    toggle('0603e523-vio-cash-sid', null, () => user && getCashBackValue())
  }, [dispatch, user, apiUrl])

  return null
}
